import { Component, OnInit } from '@angular/core';
import { InfrastructureService } from 'src/app/@core/services/infrastructure/infrastructure.service';
import { version } from '../../../../package.json';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  public uiVersion: string = version;
  public apiVersion: String;

  constructor(
    private infraService: InfrastructureService,
    public darkModeService: DarkModeService
    ) { 
    this.infraService.getAPIVersion().subscribe((apiVersion) => {
      this.apiVersion = apiVersion.version;
    });
  }

  ngOnInit() {
  }
}
